import React from "react";

function Music() {
  return (
    <div>
      <h1 className="center">Music page</h1>
    </div>
  );
}

export default Music;
